export default {
  default: {
    id: 'address_book_default',
    defaultMessage: 'Default',
  },
  cityWithPostalCode: {
    id: 'address_book_city_postal_code',
    defaultMessage: '{postalCode} {city}',
  },
  fullName: {
    id: 'global_full_name',
    defaultMessage: '{firstName} {lastName}',
  },
}
